import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { QueryKeys } from "@/queries/utils";
import { BillingPlanTerm, CandidateJobOpening } from "@/types";
import { MilestoneCompletionFormSchema } from "./schema";

export const useMarkMilestoneAsDelivered = (args: {
  jobOpeningId: string;
  onSuccess?: (data: BillingPlanTerm) => void;
}) => {
  const qc = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async (data: MilestoneCompletionFormSchema) => {
      const token = await getAccessTokenSilently();

      return request<BillingPlanTerm>({
        method: "POST",
        path: `/api/jobOpening/billing-plan-terms/${data.milestone}/submit`,
        body: JSON.stringify({
          completionDate: data.completionDate.toISOString(),
        }),
        token,
      });
    },
    onSuccess(data) {
      args.onSuccess?.(data);

      toast.success("Milestone marked as complete!");

      qc.setQueryData<CandidateJobOpening[]>(
        QueryKeys.candidateOpportunities,
        (old) => {
          if (!old) return;

          const opportunities = [...old];
          const opportunityIdx = opportunities.findIndex(
            ({ id }) => id === args.jobOpeningId,
          );

          const opportunity = opportunities[opportunityIdx];
          if (!opportunity) return;

          const candidateStatus = opportunity.candidateStatus;
          if (!candidateStatus) return;

          const billing = candidateStatus.billing;
          if (!billing) return;

          const terms = [...billing.terms];
          const termIdx = terms.findIndex(({ id }) => id === data.id);

          if (termIdx === -1) {
            return;
          }

          terms[termIdx] = data;
          billing.terms = terms;
          candidateStatus.billing = billing;
          opportunity.candidateStatus = candidateStatus;

          opportunities[opportunityIdx] = opportunity;

          return opportunities;
        },
      );

      //   qc.setQueryData<AdminJobDetails>(
      //     QueryKeys.adminJobDetails(args.jobOpeningId),
      //     (old) => {
      //       if (!old) {
      //         return old;
      //       }

      //       const candidates = [...old.candidates];
      //       const candidateIdx = candidates.findIndex(
      //         (candidate) => candidate.id === data.id,
      //       );

      //       if (candidateIdx === -1) {
      //         return old;
      //       }

      //       candidates[candidateIdx] = data;

      //       return {
      //         ...old,
      //         candidates,
      //       };
      //     },
      //   );
    },
  });

  return {
    markMilestoneAsComplete: mutate,
    isMarkingMilestoneAsComplete: isPending,
    markMilestoneAsCompleteError: error,
  };
};
